import React from 'react';

import { Flex, FlexProps } from '@joinrepublic/dls-ui-kit';

import { useAnalytics } from '@r-client/shared/data/analytics';
import { Button, Text } from '@r-client/shared/ui/core';

import { getCalendarsCollection, TCalendarEvent } from '../../../utils';
import { CalendarIcon } from '../calendar-icon';

import styles from './button-group.module.scss';

export interface IButtonGroupProps extends FlexProps {
  event: TCalendarEvent;
}

export const ButtonGroup: React.FC<
  React.PropsWithChildren<IButtonGroupProps>
> = ({ event, ...restProps }) => {
  const analytics = useAnalytics();
  const trackAnalytics = (calendarName: string) => {
    analytics.track({
      name: 'event_rsvp_calendar_button_clicked',
      params: { calendar_name: calendarName },
    });
  };
  return (
    <Flex wrap="wrap" {...restProps}>
      {getCalendarsCollection(event).map((calendar) => {
        return (
          <Button
            key={calendar.type}
            target="_blank"
            rel="nofollow noopener"
            href={calendar.url}
            size="small"
            className={styles.button}
            onClick={() => trackAnalytics(calendar.displayName)}
          >
            <span>
              <Text as="span" m="0 0.5brm 0 0" color="gray8">
                <CalendarIcon type={calendar.type} />
              </Text>
              {calendar.displayName}
            </span>
          </Button>
        );
      })}
    </Flex>
  );
};
